import { PropsWithChildren, useEffect } from "react";
import * as Sentry from "shared/providers/sentry/sentry.package";

import useAuth from "../../hooks/useAuth.hook";
import useTransformName from "shared/hooks/useTransformName.hook";

import SharedProtectedRoute from "shared/hoc/protected-route/protected-route.hoc";

const ProtectedRoute = ({ children }: PropsWithChildren) => {
  const { user, loading } = useAuth();

  const transformName = useTransformName();

  useEffect(() => {
    if (!user) {
      Sentry.setUser(null);
    } else {
      Sentry.setUser({
        id: user.id,
        email: user.email,
        name: transformName(user.firstName, user.lastName),
      });
    }

    return () => {
      Sentry.setUser(null);
    };
  }, [user, transformName]);

  return (
    <SharedProtectedRoute loggedIn={!!user} loading={!!loading}>
      {children}
    </SharedProtectedRoute>
  );
};

export default ProtectedRoute;
